export const SESSION_TAG = 'SESSION_TAG'
export const WISHLIST_TAG = 'WISHLIST_TAG'
export const CART_TAG = 'CART_TAG'
export const ORDERS_TAG = 'ORDERS_TAG'
export const ORDERS_HISTORY_TAG = 'ORDERS_HISTORY_TAG'
